module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title-data-registrant":"Melder","fullname-label":"Name","email-label":"E-Mail"},"fr":{"email-label":"E-mail","fullname-label":"Nom","title-data-registrant":"Déclarant"},"it":{"email-label":"E-mail","fullname-label":"Cognome","title-data-registrant":"Notificante"}}')
  delete Component.options._Ctor
}
